<template>
  <div class="body evel-II page_main">
    <el-card>
      <zdylayout>
        <template v-slot:query-box-filed>
          <div class="layer-header-front">
            <label class="el-form-item__label title">目录管理</label>
            <el-button class="fa-pull-right" style="float: right;margin-top:16px;" @click="$router.back(-1)">返回</el-button>
          </div>
          <div class="page_item search_main">
            <el-form
              ref="form"
              :model="form"
              label-width="80px"
              :inline="true"
              label-suffix=":"
              size="small"
            >
              <el-form-item label="目录类型" prop="type">
                <el-select v-model="form.name" placeholder="请选择" clearable>
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <div class="fa-pull-right">
                <el-form-item>
                  <el-button type="primary" @click="getDirectoryList"
                    >搜索</el-button
                  >
                </el-form-item>
              </div>
      </el-form>
          </div>
      </template>
      <template v-slot:query-box-button> </template>
      <template v-slot:layer-body-front>
        <div class="page_item">
        <div class="fl">
          <el-button type="text"> &nbsp;</el-button>
        </div>
        <div class="fa-pull-right">
          <el-button class="mb20" type="primary" @click="add">新增</el-button>
        </div>
        </div>
      </template>
      <template v-slot:body-table>
        <div class="page_item">
        <el-table
        row-key="id"
        :data="directoryList"
        :tree-props="{
        children: 'directoryList',
        hasChildren: '!directoryList'
      }"
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        style="width: 100%;"
      >
        <!-- <el-table-column type="expand">
            <template slot-scope="scope">
              <tableTree :directoryList="scope.row.directoryList"></tableTree>
            </template>
          </el-table-column> -->
            <!-- <el-table-column type="expand" class-name="table-expand-column" width="1">
            <template>

            </template>
          </el-table-column> -->
            <el-table-column
              label="编号"
              prop="directoryNo"
              :show-overflow-tooltip="false"
            ></el-table-column>
            <el-table-column
              label="目录名称"
              prop="directoryName"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column label="目录类型">
              <template slot-scope="scope">
                {{
                  scope.row.type == 1
                    ? "试题目录"
                    : scope.row.type == 2
                    ? "试卷目录"
                    : scope.row.type == 3
                    ? "课件目录"
                    : scope.row.type == 4
                    ? "课程目录"
                    : "暂无"
            }}
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="isAble">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.isAble == 0">正常</el-tag>
            <el-tag type="danger" v-else>禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="400px">
          <template slot-scope="scope">
            <el-button @click="addChild(scope.row)" type="success" size="mini"
            >添加子级
            </el-button
            >
            <el-button
              @click="editDirectory(scope.row)"
              type="primary"
              size="mini"
            >编辑
            </el-button
            >
            <el-button
              @click="delDirectory(scope.row.id)"
              type="danger"
              size="mini"
            >删除
            </el-button
            >
            <el-button
              v-if="scope.row.isAble == 0"
              @click="statusChange(scope.row.id)"
              type="warning"
              size="mini"
            >禁用
            </el-button
            >
            <el-button
              v-else
              @click="statusChange(scope.row.id)"
              type="warning"
              size="mini"
            >启用
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
        </div>
      </template>
      <template v-slot:body-pagination>
        <div class="page_item common_btm_pagination">
        <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        @size-change="sizeChange"
        @current-change="pageChange"
      ></el-pagination>
      </div>
      </template>
    </zdylayout>

    </el-card>
    <el-dialog
    class="basicForm"
    :title="title"
    :visible.sync="directoryVisible"
    width="30%"
    @close="closeDialog"
    :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="编号" prop="directoryNo">
            <el-input v-model="form.directoryNo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="目录类型" prop="type">
            <el-select v-model="form.type" :disabled="form.parentId != 0">
  <!--                <el-option label="试题目录" value="1"></el-option>-->
  <!--                <el-option label="试卷目录" value="2"></el-option>-->
              <el-option label="课件目录" value="3"></el-option>
              <el-option label="课程目录" value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="目录名称" prop="directoryName">
            <el-input v-model="form.directoryName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="状态" prop="isAble">
            <el-radio v-model="form.isAble" label="0">启用</el-radio>
            <el-radio v-model="form.isAble" label="1">禁用</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span=24>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="form.remark" type="textarea"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="directoryVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveDirectory">确 定</el-button>
    </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api/new/exam.js";
import tableTree from "@/components/tableTree";

export default {
  components: { tableTree },
  data() {
    return {
      title: "",
      directoryList: [],
      directoryVisible: false,
      form: {
        parentId: 0,
        type: undefined,
        name: undefined,
        directoryName: "",
        directoryNo: "",
        remark: "",
        isAble: "0",
        enterpriseId: undefined
      },
      rules: {
        directoryName: [
          { required: true, message: "请输入目录名称", trigger: "blur" }
          // {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
        ],
        type: [{ required: true, message: "请选择目录类型" }],
        directoryNo: [
          { required: true, message: "请输入编号", trigger: "blur" },
          { min: 1, max: 32, message: "长度在 1 到 32 个字符", trigger: "blur" }
        ],
        isAble: [{ required: true, message: "请选择目录状态", trigger: "blur" }]
      },
      page: 1,
      pageSize: 10,
      total: 0, // 总条数
      typeOptions: [
        //   {
        //   value: 1,
        //   label: '试题目录'
        // },
        //   {
        //   value: 2,
        //   label: '试卷目录'
        // },
        {
          value: 3,
          label: "课件目录"
        },
        {
          value: 4,
          label: "课程目录"
        }
      ],
      tableLoading: true
    };
  },
  mounted() {
    this.getDirectoryList();
    this.form.enterpriseId = JSON.parse(
      localStorage.getItem("userinfo")
    ).enterpriseId;
  },
  methods: {
    sizeChange(e) {
      this.pageSize = e;
      this.getDirectoryList();
      console.log(e);
    },
    pageChange(e) {
      this.page = e;
      this.getDirectoryList();
      console.log(e);
    },
    add() {
      this.directoryVisible = true;
      this.title = "添加目录";
    },
    closeDialog() {
      this.form = {
        parentId: 0,
        directoryName: "",
        directoryNo: "",
        remark: "",
        isAble: "0"
      };
      this.$refs["form"].resetFields();
    },
    statusChange(id) {
      this.$confirm("是否确认修改状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        api.delDirectory({ id, status: 1 }).then(res => {
          if (res.code == 0) {
            this.$message.success("成功");
            this.getDirectoryList();
          } else {
            this.$message.error("失败");
          }
        });
      });
    },
    editDirectory(row) {
      this.form = {
        id: row.id,
        type: String(row.type),
        parentId: row.firstParentId,
        directoryName: row.directoryName,
        directoryNo: row.directoryNo,
        remark: row.remark,
        isAble: String(row.isAble)
      };
      this.title = "修改";
      this.directoryVisible = true;
    },
    delDirectory(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        api.delDirectory({ id, status: 0 }).then(res => {
          if (res.code == 0) {
            this.$message.success("成功");
            this.getDirectoryList();
          } else {
            this.$message.error("失败");
          }
        });
      });
    },
    addChild(row) {
      this.form.parentId = row.id;
      this.form.type = String(row.type);
      this.directoryVisible = true;
      this.title = "添加子级"
    },
    saveDirectory() {
      this.$refs.form.validate(validate => {
        if (validate == false) return;
        let p = {
          ...this.form,
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId
        };
        delete p.name;

        api.saveDirectory(p).then(res => {
          if (res.code == 0) {
            this.$message.success("成功");
            this.directoryVisible = false;
            this.form = {
              parentId: 0,
              directoryName: "",
              directoryNo: "",
              remark: "",
              isAble: "0"
            };
            this.getDirectoryList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    getDirectoryList() {
      this.tableLoading = true;
      let param = {
        ...this.form,
        page: this.page,
        pageSize: this.pageSize,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };
      if (param.name) {
        param.type = param.name;
        delete param.name;
      }
      api.directoryList(param).then(res => {
        this.tableLoading = false;
        this.directoryList = res.data.records;
        this.total = res.data.total;
      });
    },
    resetForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
        this.getQuestionBankList();
      });
    }
  },
  watch: {
    "$store.state.addChildDirectory"(v) {
      this.addChild(v);
    },
    "$store.state.editDirectory"(v) {
      this.editDirectory(v);
    },
    "$store.state.delDirectory"(v) {
      this.delDirectory(v);
    },
    "$store.state.statusChangeDirectory"(v) {
      this.statusChange(v);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__expanded-cell[class*="cell"] {
  padding: 0 !important;
}

/deep/ .el-table__expand-column .cell {
  display: none !important;
}
.page_main {
  .page_item{
    padding: 5px 15px;
  }
  .search_main{
    padding: 0;
    margin: 0 15px;
    border-bottom: 1px solid rgba(226,226,226,1);
    .el-form-item{
      margin: 11px 0;
    }
  }
}
.layer-header-front{
  .title{
    font-size: 18px;
    height: 65px;
    line-height: 65px;
    padding: 0;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/directory.vue